module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-player",
    on: {
      "keydown": function($event) {
        _vm.hotkey(_vm.e)
      }
    }
  }, [(_vm.$route.name === 'videoPlayer') ? _c('div', [_c('timeline'), _vm._v(" "), (_vm.instanceId) ? _c('h1') : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.video) ? _c('div', {
    staticClass: "panel video-player-wrapper"
  }, [_c('div', {
    staticClass: "panel-body nopad"
  }, [_c('div', {
    staticClass: "col-sm-12 video-wrapper",
    class: {
      'col-md-9': !_vm.expanded
    },
    attrs: {
      "id": "video-wrapper"
    }
  }, [_c('div', {
    staticClass: "video-player-background"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', {
    staticClass: "clearfix"
  }, [(_vm.instanceId) ? _c('router-link', {
    staticClass: "course-link",
    attrs: {
      "to": {
        name: 'course',
        params: {
          termId: _vm.$route.query.term,
          courseId: _vm.video.course.courseId,
          instanceId: _vm.instanceId
        }
      }
    }
  }, [_vm._v("\n                                \n                                " + _vm._s(_vm.video.course.name) + " \n                            ")]) : _vm._e(), _vm._v("\n                            > \n                            " + _vm._s(_vm.video.title) + " - " + _vm._s(_vm._f("minutesAndSeconds")(_vm.totalDuration)) + "\n                            "), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Videoplayer Shortcuts: space &#61 pause, up/down &#61 speed, left&#47;right &#61 10sec skips, F &#61 full screen, D &#61 Distraction Free View'),
      expression: "'Videoplayer Shortcuts: space &#61 pause, up/down &#61 speed, left&#47;right &#61 10sec skips, F &#61 full screen, D &#61 Distraction Free View'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ttto-progress-wrapper"
  }, [_c('div', {
    staticClass: "ttto-progress",
    style: ({
      width: _vm.totalProgress + '%'
    })
  })]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-expand",
    on: {
      "click": function($event) {
        _vm.toggleExpand()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hotkey-layer",
    on: {
      "click": function($event) {
        _vm.onHotkeyLayerClick($event)
      }
    }
  }, [_c('poly-video', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.video.video_chapters),
      expression: "video.video_chapters"
    }],
    ref: "videoPlayer",
    class: {
      'hide-annotations': _vm.showAnnotations === false
    },
    attrs: {
      "sources": [_vm.videoPlayerUrl],
      "vjsOptions": _vm.videoPlayerVjsOptions,
      "persistPlaybackSpeed": true,
      "persistPlaybackQuality": true
    },
    on: {
      "click": function($event) {
        _vm.test()
      },
      "ready": function($event) {
        _vm.playerReady()
      },
      "play": function($event) {
        _vm.loadAnnotations()
      },
      "loadedsource": function($event) {
        _vm.onVideoLoad()
      },
      "ended": function($event) {
        _vm.playNextChapter($event)
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-3 chapters-wrapper",
    class: {
      'col-md-push-9': _vm.expanded
    }
  }, [_vm._m(0), _vm._v(" "), _c('VuePerfectScrollbar', {
    staticClass: "scroll-area"
  }, [(_vm.selectedChapter) ? _c('ul', {
    staticClass: "chapters"
  }, _vm._l((_vm.video.video_chapters), function(chapter) {
    return _c('li', {
      staticClass: "chapter row",
      class: {
        'selected': _vm.selectedChapter.id === chapter.id
      },
      on: {
        "click": function($event) {
          _vm.selectChapter(chapter)
        }
      }
    }, [(chapter.heading) ? _c('div', {
      staticClass: "chapter-heading"
    }, [_vm._v(_vm._s(chapter.heading))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9"
    }, [_vm._v(_vm._s(chapter.title))]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3 text-right"
    }, [_vm._v(_vm._s(_vm._f("minutesAndSeconds")(chapter.duration)))]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 chapter-progress-wrapper"
    }, [_c('div', {
      staticClass: "ttto-progress-wrapper"
    }, [(_vm.selectedChapter.id === chapter.id) ? _c('i', {
      staticClass: "current-chapter fa fa-circle"
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "ttto-progress",
      style: ({
        width: _vm.chapterProgress(chapter.progress, chapter.duration) + '%'
      })
    })])])])
  })) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "comments-wrapper",
    class: {
      'col-md-9': _vm.expanded, 'col-md-pull-3': _vm.expanded
    }
  }, [_c('div', {
    staticClass: "tabs clearfix",
    class: {
      'expanded': _vm.expanded
    }
  }, [_c('ul', [_c('li', {
    class: {
      'active': _vm.showTab === 'description'
    },
    on: {
      "click": function($event) {
        _vm.setTab('description')
      }
    }
  }, [_vm._v("Description")]), _vm._v(" "), (_vm.video.exercise && _vm.$route.name === 'videoPlayer') ? _c('li', {
    class: {
      'active': _vm.showTab === 'exercise'
    },
    on: {
      "click": function($event) {
        _vm.setTab('exercise')
      }
    }
  }, [_vm._v("\n                            Exercise\n                            "), (_vm.video.exercise.exercise_hand_ins.length > 0) ? _c('img', {
    attrs: {
      "src": require("../assets/img/exercise-icon-grey.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../assets/img/exercise-icon.png")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.video.exercise && _vm.$route.name === 'campus-dashboard') ? _c('li', {
    class: {
      'active': _vm.showTab === 'exercise'
    },
    on: {
      "click": function($event) {
        _vm.setTab('exercise')
      }
    }
  }, [_vm._v("\n                            Exercise\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.assignmentData && _vm.video.assignment && _vm.$route.name === 'videoPlayer') ? _c('li', {
    class: {
      'active': _vm.showTab === 'assignment'
    },
    on: {
      "click": function($event) {
        _vm.setTab('assignment')
      }
    }
  }, [_vm._v("\n                            Assignment\n                            "), ((_vm.assignmentData.submissions) ||
    (_vm.assignmentData && new Date(_vm.assignmentData.dueDate) < new Date())) ? _c('img', {
    attrs: {
      "src": require("../assets/img/assignment-icon-grey.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../assets/img/assignment-icon.png")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.assignmentData && _vm.video.assignment && _vm.$route.name === 'campus-dashboard') ? _c('li', {
    class: {
      'active': _vm.showTab === 'assignment'
    },
    on: {
      "click": function($event) {
        _vm.setTab('assignment')
      }
    }
  }, [_vm._v("\n                            Assignment\n                        ")]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.showTab === 'comments'
    },
    on: {
      "click": function($event) {
        _vm.setTab('comments')
      }
    }
  }, [_vm._v("\n                            Comments\n                            "), (_vm.comments) ? _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.comments.length))]) : _vm._e()]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.showTab === 'resources'
    },
    on: {
      "click": function($event) {
        _vm.setTab('resources')
      }
    }
  }, [_vm._v("Resources")]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.showTab === 'transcript'
    },
    on: {
      "click": function($event) {
        _vm.setTab('transcript')
      }
    }
  }, [_vm._v("Live Transcript")])])]), _vm._v(" "), (_vm.video) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTab === 'description'),
      expression: "showTab==='description'"
    }],
    staticClass: "description"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('h3', {
    staticClass: "video-title"
  }, [_vm._v(_vm._s(_vm.video.title))]), _vm._v(" "), _c('div', {
    staticClass: "video-description-cms-text",
    domProps: {
      "innerHTML": _vm._s(_vm.video.description)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 exercise-sidebar"
  }, [(_vm.video.lesson_files && _vm.video.lesson_files.length > 0) ? _c('h4', [_vm._v("Lesson Files")]) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((_vm.video.lesson_files), function(file) {
    return _c('li', [_c('a', {
      attrs: {
        "href": file.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(_vm._f("filenameFromUrl")(file.url)))])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.video) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTab === 'files'),
      expression: "showTab==='files'"
    }],
    staticClass: "description"
  }, [_c('h4', [_vm._v("Lesson Files")]), _vm._v(" "), _c('ul', _vm._l((_vm.video.lesson_files), function(file) {
    return _c('li', [_c('a', {
      attrs: {
        "href": file,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(_vm._f("filenameFromUrl")(file.url)))])])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTab === 'transcript' && _vm.selectedChapter && _vm.selectedChapter.transcript),
      expression: "showTab==='transcript' && selectedChapter && selectedChapter.transcript"
    }],
    staticClass: "transcript-container video-tabs-content"
  }, [(_vm.transcriptLoaded === false) ? _c('div', {
    staticClass: "transcript"
  }, [_vm._v("Live Transcripts will appear here when playing a video chapter.")]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "transcript",
    staticClass: "transcript",
    attrs: {
      "id": "transcript"
    },
    on: {
      "click": function($event) {
        _vm.jumpToTime($event.target.parentNode.dataset.begin)
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTab === 'resources'),
      expression: "showTab==='resources'"
    }]
  }, [_c('div', {
    staticClass: "resources"
  }, [(_vm.instanceId && _vm.video.week) ? _c('div', [_c('resources', {
    attrs: {
      "instanceId": _vm.instanceId,
      "currentWeek": _vm.video.week
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTab === 'assignment'),
      expression: "showTab==='assignment'"
    }],
    staticClass: "video-tabs-content"
  }, [(_vm.assignmentData) ? _c('assignment-submission', {
    attrs: {
      "data": _vm.assignmentData
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTab === 'exercise'),
      expression: "showTab==='exercise'"
    }],
    staticClass: "video-tabs-content exercise"
  }, [(_vm.video.exercise) ? _c('div', {
    staticClass: "exercise-wrapper"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('img', {
    staticClass: "background",
    attrs: {
      "src": _vm.exerciseImage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 exercise-description",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('h4', [(_vm.$route.name !== 'campus-dashboard') ? _c('span', [_vm._v("Week " + _vm._s(_vm.$route.query.week) + ", ")]) : _vm._e(), _vm._v(_vm._s(_vm.video.exercise.title))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.video.exercise.description)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-3"
  }, [(_vm.video.exercise.image) ? _c('img', {
    staticClass: "exercise-image",
    attrs: {
      "src": _vm.exerciseImage
    },
    on: {
      "click": function($event) {
        _vm.showLightBox = true
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-3 exercise-sidebar"
  }, [_c('div', {
    staticClass: "exercise-files"
  }, [(_vm.$route.name !== 'campus-dashboard') ? _c('div', [_c('h4', [_vm._v("Due Date"), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Find your exercise due date below.'),
      expression: "'Find your exercise due date below.'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })]), _vm._v(" "), (_vm.video.exercise.dueDate) ? _c('div', [_vm._v("\n                                            " + _vm._s(_vm._f("localDate")(_vm.video.exercise.dueDate))), _c('br'), _vm._v(" "), _c('countdown', {
    attrs: {
      "date": _vm.video.exercise.dueDate
    }
  })], 1) : _c('div', [_vm._v("\n                                            " + _vm._s(_vm._f("localDate")(_vm.friday))), _c('br'), _vm._v(" "), _c('countdown', {
    attrs: {
      "date": _vm.friday
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('h4', [_vm._v("Exercise Files:"), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Find files here required for the exercise'),
      expression: "'Find files here required for the exercise'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })]), _vm._v(" "), ((_vm.video.exercise.files && _vm.video.exercise.files.length > 0) ||
    (_vm.video.exercise.watermarkedFiles && _vm.video.exercise.watermarkedFiles.length > 0)
  ) ? _c('ul', [_vm._l((_vm.video.exercise.files), function(file) {
    return _c('li', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.downloadFile(file, 'exercise', _vm.video.exercise.id)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("filenameFromUrl")(file)))])])
  }), _vm._v(" "), _vm._l((_vm.video.exercise.watermarkedFiles), function(file) {
    return _c('li', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.downloadFile(file, 'exercise', _vm.video.exercise.id)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("filenameFromUrl")(file)))])])
  })], 2) : _c('p', [_vm._v("No files for this exercise")])]), _vm._v(" "), (_vm.$route.name !== 'campus-dashboard') ? _c('div', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitHandIn()
      }
    }
  }, [(_vm.video.exercise.fileRequired === true) ? _c('h4', [_vm._v("Submit Exercise"), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Drag your file(s) here to submit.'),
      expression: "'Drag your file(s) here to submit.'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })]) : _vm._e(), _vm._v(" "), (_vm.video.exercise.fileRequired === true) ? _c('dropzone', {
    ref: "exerciseUpload",
    attrs: {
      "id": "exerciseUpload",
      "url": "#",
      "use-custom-dropzone-options": true,
      "thumbnail-height": 0,
      "dropzone-options": _vm.dropzoneOptions
    }
  }) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "self-assessment"
  }, [_c('h4', [_vm._v("Self Assessment"), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Let us know how you feel about this week\'s content for this course'),
      expression: "'Let us know how you feel about this week\\'s content for this course'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })]), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.handIn.assessment),
      expression: "handIn.assessment"
    }],
    attrs: {
      "value": "3",
      "type": "radio",
      "name": "confidence"
    },
    domProps: {
      "checked": _vm._q(_vm.handIn.assessment, "3")
    },
    on: {
      "__c": function($event) {
        _vm.handIn.assessment = "3"
      }
    }
  }), _vm._v("I nailed this")])]), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.handIn.assessment),
      expression: "handIn.assessment"
    }],
    attrs: {
      "value": "2",
      "type": "radio",
      "name": "confidence"
    },
    domProps: {
      "checked": _vm._q(_vm.handIn.assessment, "2")
    },
    on: {
      "__c": function($event) {
        _vm.handIn.assessment = "2"
      }
    }
  }), _vm._v("I mostly get this")])]), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.handIn.assessment),
      expression: "handIn.assessment"
    }],
    attrs: {
      "value": "1",
      "type": "radio",
      "name": "confidence"
    },
    domProps: {
      "checked": _vm._q(_vm.handIn.assessment, "1")
    },
    on: {
      "__c": function($event) {
        _vm.handIn.assessment = "1"
      }
    }
  }), _vm._v("I need help")])])]), _vm._v(" "), (_vm.handIn.assessment == 1) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._v("\n                                            Are you stuck? Please reach out to your supervisor in chat or create a "), _c('router-link', {
    attrs: {
      "to": "/support"
    }
  }, [_vm._v("Support Ticket")]), _vm._v(".\n                                        ")], 1) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")])], 1), _vm._v(" "), (_vm.video.exercise.exercise_hand_ins.length > 0) ? _c('div', {
    staticClass: "previous-submissions"
  }, [_c('h4', [_vm._v("Submitted Files")]), _vm._v(" "), _vm._l((_vm.video.exercise.exercise_hand_ins), function(hand_in) {
    return _c('div', [_vm._l((hand_in.url), function(file) {
      return _c('div', {
        staticClass: "hand-in-link"
      }, [_c('a', {
        attrs: {
          "href": file,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(_vm._f("filenameFromUrl")(file)) + "\n                                                ")])])
    }), _vm._v(" "), _c('div', {
      staticClass: "separator"
    }, [_vm._v("\n                                                " + _vm._s(_vm._f("shortDate")(hand_in.createdAt)) + "\n                                            ")])], 2)
  })], 2) : _vm._e()]) : _vm._e()])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTab === 'comments'),
      expression: "showTab==='comments'"
    }],
    staticClass: "video-tabs-content"
  }, [(_vm.comments) ? _c('ul', {
    staticClass: "comments"
  }, _vm._l((_vm.comments), function(comment) {
    return _c('li', [_c('div', {
      staticClass: "row top-level"
    }, [_c('div', {
      staticClass: "col-xs-1"
    }, [(comment.user.avatar) ? _c('img', {
      attrs: {
        "src": comment.user.avatar
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9"
    }, [_c('p', {
      staticClass: "author"
    }, [_vm._v("\n                                        " + _vm._s(comment.user.firstName) + " " + _vm._s(comment.user.lastName) + " at "), _c('span', {
      staticClass: "jump-link",
      on: {
        "click": function($event) {
          _vm.jumpToTime(comment.time)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("minutesAndSeconds")(comment.time)))])]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(comment.text)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2"
    }, [_c('div', [_vm._v(_vm._s(_vm._f("timeSince")(comment.createdAt)) + " ago")]), _vm._v(" "), _c('div', [_c('button', {
      staticClass: "btn btn-xs reply-button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showReplyForm = comment.id
        }
      }
    }, [_vm._v("Reply")]), _vm._v(" "), (_vm.localStorage.roles.includes('CourseAdmin') || _vm.localStorage.roles.includes('Admin')) ? _c('button', {
      staticClass: "btn btn-xs delete-button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deleteComment(comment)
        }
      }
    }, [_vm._v("\n                                            Delete\n                                        ")]) : _vm._e()])])]), _vm._v(" "), (comment.children.length > 0) ? _c('ul', {
      staticClass: "replies"
    }, _vm._l((comment.children), function(child) {
      return _c('li', [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "col-xs-1"
      }, [(child.user.avatar) ? _c('img', {
        attrs: {
          "src": child.user.avatar
        }
      }) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-9"
      }, [_c('p', {
        staticClass: "author"
      }, [_vm._v("\n                                                " + _vm._s(child.user.firstName) + " " + _vm._s(child.user.lastName) + " at "), _c('span', {
        on: {
          "click": function($event) {
            _vm.jumpToTime(comment.time)
          }
        }
      }, [_vm._v(_vm._s(_vm._f("minutesAndSeconds")(comment.time)))])]), _vm._v(" "), _c('div', {
        domProps: {
          "innerHTML": _vm._s(child.text)
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-2"
      }, [_c('div', [_vm._v(_vm._s(_vm._f("timeSince")(child.createdAt)) + " ago")]), _vm._v(" "), (_vm.localStorage.roles.includes('CourseAdmin') || _vm.localStorage.roles.includes('Admin')) ? _c('button', {
        staticClass: "btn btn-xs delete-button",
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.deleteComment(child)
          }
        }
      }, [_vm._v("\n                                                Delete\n                                            ")]) : _vm._e()])])])
    })) : _vm._e(), _vm._v(" "), (_vm.showReplyForm === comment.id) ? _c('form', {
      on: {
        "submit": function($event) {
          $event.preventDefault();
          _vm.addComment(comment.id, comment.user)
        }
      }
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('vue-html5-editor', {
      attrs: {
        "content": _vm.content,
        "height": 200
      },
      on: {
        "change": function($event) {
          _vm.updateCommentReply($event, comment.id)
        }
      }
    })], 1), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs reply-button",
      attrs: {
        "type": "submit"
      }
    }, [_vm._v("Submit Comment Reply")])]) : _vm._e()])
  })) : _vm._e(), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addComment()
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Add Timeline Comment:"), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Add and reply to comments directly on the timeline. Great for asking and answering questions specific to a point in time. Set your time marker to a place and add a comment!'),
      expression: "'Add and reply to comments directly on the timeline. Great for asking and answering questions specific to a point in time. Set your time marker to a place and add a comment!'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })]), _vm._v(" "), _c('vue-html5-editor', {
    attrs: {
      "content": _vm.content,
      "height": 200
    },
    on: {
      "change": _vm.updateComment
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Add Comment")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.showLightBox) ? _c('div', {
    staticClass: "lightbox",
    on: {
      "click": function($event) {
        _vm.showLightBox = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove",
    on: {
      "click": function($event) {
        _vm.showLightBox = false
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.exerciseImage
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  })]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Lesson Progress")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2bee7002!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoPlayer.vue
// module id = 2002
// module chunks = 2